export default "__VITE_ASSET__c0259908__"